import { createRef } from "react";

/**
 * Method responsible for returning the event init object for delivering
 * the input's new value on change.
 */
const getInputEventInit = (value) => {
  return { target: { value } };
};

export function InputBox(props) {
  const editable = props.editable ?? true;
  const decimalPlaces = props.decimalPlaces ?? 2;
  const step = props.step ?? 1;
  const min = props.min ? parseFloat(props.min).toFixed(decimalPlaces) : 0;
  const max = props.max ? parseFloat(props.max).toFixed(decimalPlaces) : 0;
  const value = props.iniValue
    ? parseFloat(props.iniValue).toFixed(decimalPlaces)
    : 0;
  const input = createRef();

  function handleInputValueIncrease() {
    if (editable) {
      const newInputValue = getNewInputValueAdjusted(
        parseFloat(input.current.value) + parseFloat(step)
      );
      input.current.value = newInputValue;
      dispatchInputChangeEvent(getInputEventInit(newInputValue));
    }
  }

  function handleInputValueDecrease() {
    if (editable) {
      const newInputValue = getNewInputValueAdjusted(
        parseFloat(input.current.value) - parseFloat(step)
      );
      input.current.value = newInputValue;
      dispatchInputChangeEvent(getInputEventInit(newInputValue));
    }
  }

  /**
   * Method responsible for manually dispatching the change event
   * on the input. This is needed here because React overrides the
   * change event on the inputs, so it is not automatically triggered
   * as the input changes are not being applied directly.
   */
  function dispatchInputChangeEvent(event) {
    input.current.dispatchEvent(new Event("change", event));
    callFathersChangeEvent(event);
  }

  /**
   * Method responsible for calling the father component's change
   * handler, after the input update.
   */
  function callFathersChangeEvent(event) {
    if (typeof props.onChange === "function") props.onChange(event);
  }

  /**
   * Method responsible for adjusting the new input value given
   * the maximum and minimum constraints.
   */
  function getNewInputValueAdjusted(newInputValue) {
    return newInputValue < min
      ? min
      : newInputValue > max
      ? max
      : newInputValue.toFixed(decimalPlaces);
  }

  /**
   * Method responsible for returning the title of the input, when
   * it is defined.
   */
  function getInputTitle() {
    return (
      props.tittle && (
        <div className="inputStyleTittleBox" style={{ width: "65px" }}>
          {props.tittle}
        </div>
      )
    );
  }

  /**
   * Method responsible for returning the unit measure of the input
   * value represented, when it is defined.
   */
  function getInputUnit() {
    return props.unit && <div className="inputStyleTextBox">{props.unit}</div>;
  }

  function showButtons() {
    return (
      props.editable && (
        <div className="inputStyleArrowsBox">
          <div
            id={"changeValueUp-" + props.id}
            className="inputStyleArrowUp"
            onClick={handleInputValueIncrease.bind(this)}
          />
          <div
            id={"changeValueDown-" + props.id}
            className="inputStyleArrowDown"
            onClick={handleInputValueDecrease.bind(this)}
          />
        </div>
      )
    );
  }

  const NOHOVER = props.editable
    ? "inputStyle"
    : "inputStyle inputStyleNOHOVER";

  return (
    <div style={{ display: "flex", margin: "10px 10px" }}>
      {getInputTitle()}
      <div className={NOHOVER}>
        {getInputUnit()}
        <input
          id={props.id}
          step={props.step}
          className={"inputStyleField decimalsPlaces3"}
          min={props.min}
          max={props.max}
          readOnly={!props.editable}
          onChange={callFathersChangeEvent.bind(this)}
          value={value}
          ref={input}
          style={{ zIndex: 10 }}
          data-unit={props.unit}
        />
        {showButtons()}
      </div>
    </div>
  );
}
